export enum RoadmapItemStatus {
  /** Already shipped and available in the app */
  DONE = "DONE",
  /** Currently being built */
  IN_PROGRESS = "IN_PROGRESS",
  /** Planned, not started yet */
  UPCOMING = "UPCOMING",
}
